export default "__VITE_ASSET__Bjb0Vs_w__"